<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <v-spacer class="mb-5 logoExam"></v-spacer>
        <!--<img src="@/assets/examenis_logo.svg" class="mb-5 logoExam">-->
        <blockquote>
          Auf Wiedersehen
          <footer>
            <small>
              <em></em>
            </small>
          </footer>
          <br>
          Sie werden in Kürze auf die Anmeldeseite weitergeleitet.

        </blockquote>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import Vue from 'vue'
import api from './Login.js'

export default {
  name: 'Logout',
  methods: {
    doLogoutDone : function () {
      this.$router.push('/')
    }
  },
  mounted () {
    Vue.prototype.$api.showIdle()
    Vue.prototype.$api.credentials = null
    api.doLogout(this.form, this.doLogoutDone)
    Vue.prototype.$api.resetCredentials(this)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
